import React, { Fragment } from 'react';

import * as illustratorPlacer from 'illustrator-placer';
import { getPrintSvgData } from '../../../util/newEngineUtils';
import ButtonExport from './ButtonExport';
import * as analytics from '../../../util/analytics';

const IllustratorExportButtons = ({ highchart, sizeId, chart, scale, id }) => {
  const { sizes, type: chartType, data } = chart;
  const { horizontalBarType } = data;
  const { width } = sizes[sizeId];

  illustratorPlacer.setup();

  const placeInIllustrator = ({ replace = false }) => {
    analytics.track('event', 'Print chart', 'Place in illustrator', replace);

    const printSVG = getPrintSvgData(sizeId, highchart);
    const exportData = {};
    exportData.original = printSVG;
    exportData.svg = illustratorPlacer.clean(printSVG, { chartType, horizontalBarType });

    // TODO: revisit this
    const getXAxisLabelsWidth = (originalSvg, chartType, horizontalBarType) => {
      if (chartType === 'bar' && horizontalBarType !== 'aboveBar') {
        let condition;
        const gridlineString =
          horizontalBarType === 'normal'
            ? 'highcharts-yaxis-grid" data-z-index="1"><path data-z-index="1" class="highcharts-grid-line" d="M '
            : 'highcharts-yaxis-grid bar-yaxis" data-z-index="1"><path data-z-index="1" class="highcharts-grid-line" d="M ';
        const gridLineRegex = new RegExp(gridlineString);
        // if yaxis gridLine goes before zero line we calculate x-axis label width for bar charts based on first gridline, for everything else it set to zero and not handled in the plugin code.
        const gridLineFirst = gridLineRegex.test(originalSvg);
        if (gridLineFirst) {
          condition = gridlineString;
        } else {
          condition = `highcharts-yaxis-grid" data-z-index="1"><path data-z-index="1" class="zero-line" d="M `;
          if (!originalSvg.split(condition)[1])
            condition = `</path><path data-z-index="1" class="highcharts-grid-line" d="M `;
        }
        return +originalSvg.split(condition)[1].split(' ')[0];
      } else return 3;
    };

    const xAxisLabelsWidth = getXAxisLabelsWidth(exportData.original, chartType, horizontalBarType);

    const illustratorPlacerMethod = replace ? illustratorPlacer.replace : illustratorPlacer.place;
    illustratorPlacerMethod(exportData.svg, {
      convertToCMYK: true,
      optimizeText: true,
      scale: 1 / scale,
      width,
      name: id,
      chartType,
      horizontalBarType,
      xAxisLabelsWidth: xAxisLabelsWidth - 3,
      data: { chartlosId: id },
    }).catch((err) => console.error('chart could not be placed in illustrator'));
  };

  return (
    <Fragment>
      <ButtonExport action={placeInIllustrator}>Place in Illustrator</ButtonExport>
      <ButtonExport action={placeInIllustrator.bind(null, { replace: true })}>
        Replace selection
      </ButtonExport>
    </Fragment>
  );
};

export default IllustratorExportButtons;
